'use client'

import React from 'react'
import { useForm } from 'react-hook-form'
import type { IPersonTypeForm } from '@/schemas/auth/authFormSchemas'
import Radio from '~/components/Form/Radio'
import CompanySignUpForm from './_components/CompanySignUpForm'
import PersonSignUpForm from './_components/PersonSignUpForm'

const SignUp: React.FC = () => {
    // Pessoa física já marcada no primeiro render (antes um efeito marcava depois, e o formulário PJ aparecia antes).
    const { register, watch } = useForm<IPersonTypeForm>({ defaultValues: { personType: 'PF' } })

    const naturalPerson = watch('personType') === 'PF'

    return (
        <div className="container flex flex-col gap-12 mx-auto mt-12 px-12">
            <div className="flex gap-4 -mb-8 lg:ml-28 max-lg:justify-center">
                <Radio id="PF" labelText="Pessoa Física" value="PF" register={register('personType')} />
                <Radio id="PJ" value="PJ" labelText="Pessoa Jurídica" register={register('personType')} />
            </div>
            {naturalPerson ? <PersonSignUpForm /> : <CompanySignUpForm />}
        </div>
    )
}

export default SignUp
